import React, { useRef } from "react";
import IconSvg from "./IconSvg";
import "./style.css";
import { ArrowBack } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";

const Header = ({ selectedCeeId, onCeeIdChange, ceeOptions, quickStats }) => {
  const searchInputRef = useRef(null);
  const navigate = useNavigate();
  const inCompletedStudents = quickStats.totalStudentsInBatch - quickStats.totalCEETakers;
  return (
    <header className="mb-6">
      <div className="header-container">
        <div className="header-title-group">
          <h1
            className="header-title"
            onClick={() => navigate("/CollegeInfoPage")}
          >
            <ArrowBack className="mr-3 cursor-pointer" />
            <span className="header-title-gradient">CareerCarve</span>
            <span className="text-gray-900 ml-2">College Admin Dashboard</span>
          </h1>
          <p className="header-subtitle">Batch Analysis & Placement Insights</p>
        </div>
        <div className="header-actions">
          <select
            className="header-select"
            value={selectedCeeId}
            onChange={onCeeIdChange}
          >
            {ceeOptions.map((option) => (
              <option key={option.id} value={option.id}>
                {option.name}
              </option>
            ))}
          </select>
          <div className="header-search-container">
            <div className="header-search-input-wrapper">
              <IconSvg
                path="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                className="h-5 w-5 text-gray-400 mr-2"
              />
              <input
                type="text"
                id="searchInput"
                placeholder="Search Student Name"
                className="header-search-input"
                ref={searchInputRef}
                autoComplete="off"
              />
            </div>
          </div>
          {/* <button style={{ border: "none" }} className="header-export-button">
            Export Raw Data
          </button> */}
        </div>
      </div>
      {/* Quick Stats Overview */}
      {quickStats && (
        <div className="grid grid-cols-1 md-grid-cols-3 gap-4 mt-2">
          <div className="bg-white rounded-lg shadow-sm p-4 h-20">
            <div className="flex items-center">
              <div className="p-2 rounded-lg bg-primary-50 mr-3">
                <IconSvg
                  path="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"
                  className="h-6 w-6 text-primary-600"
                />
              </div>
              <div className="flex flex-col gap-1">
                <span className="text-sm text-gray-500">Exam Takers</span>
                <span className="text-xl font-semibold text-gray-900">
                  {quickStats.totalCEETakers}/{quickStats.totalStudentsInBatch}
                </span>
              </div>
            </div>
          </div>
          <div className="bg-white rounded-lg shadow-sm p-4 h-20">
            <div className="flex items-center">
              <div className="p-2 rounded-lg bg-green-50 mr-3">
                <IconSvg
                  path="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"
                  className="h-6 w-6 text-green-600"
                />
              </div>
              <div className="flex flex-col gap-1">
                <span className="text-sm text-gray-500">
                  Avg. Employability
                </span>
                <span className="text-xl font-semibold text-gray-900">
                  {quickStats.avgEmployability}
                </span>
              </div>
            </div>
          </div>
          <div className="bg-white rounded-lg shadow-sm p-4 h-20">
            <div className="flex items-center">
              <div className="p-2 rounded-lg bg-secondary-50 mr-3">
                <IconSvg
                  path="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                  className="h-6 w-6 text-secondary-600"
                />
              </div>
              <div className="flex flex-col gap-1">
                <span className="text-sm text-gray-500">
                  Projected Avg. Salary
                </span>
                <span className="text-xl font-semibold text-gray-900">
                  {quickStats.projectedAvgSalary}
                </span>
              </div>
            </div>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;
